import { NgModule } from '@angular/core';
import { BuNotificationComponent } from './bu-notification/bu-notification.component';

@NgModule({
  imports: [],
  declarations: [BuNotificationComponent],
  exports: [BuNotificationComponent]
})
export class BuNotificationModule { }
